import i18next from 'i18next';
import { capitalize } from 'utils';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { Image } from 'antd';
import { DOCUMENTATION_TIME_PLACEHOLDER } from 'infrastructure/consts/tables';
import { convertSecondsToTime } from 'utils/timeHelper';
import { tableSortMap } from 'infrastructure/antd/functions/create-sort-order';

import s from './styles.module.scss';

import type { SortState } from 'infrastructure/types';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';
import type { ISmsActivity } from 'infrastructure/interfaces';

interface Props {
  documentationTimeSort: SortState;
}

export const columns = ({
  documentationTimeSort,
}: Props): IBaseTableColumns<ISmsActivity> => {
  return [
    {
      label: i18next.t('labels.dateTime'),
      key: 'createdAt',
      width: '120px',
      render(value) {
        return (
          <span data-cy="sms-date">
            {DateFormatter({
              date: value,
              format: DateFormats['MM-dd-yyyy h:mm a'],
            })}
          </span>
        );
      },
    },
    {
      label: i18next.t('labels.documentationTime'),
      key: 'documentationTime',
      align: 'center',
      width: '120px',
      render(documentationTime?: number | null) {
        const actionTime = !documentationTime
          ? DOCUMENTATION_TIME_PLACEHOLDER
          : convertSecondsToTime(documentationTime);
        return <span data-cy="sms-documentation-time">{actionTime}</span>;
      },
      sortable: true,
      sortKey: 'documentationTime',
      sortOrder: tableSortMap[documentationTimeSort],
    },
    {
      label: i18next.t('labels.smsTextElectronicallySignedBy'),
      key: 'message',
      width: '500px',
      responsive: ['md'],
      render(value, record) {
        return (
          <>
            {record.mediaUrl && (
              <span className={s.media}>
                <Image width={20} src={record.mediaUrl} />
              </span>
            )}
            <span data-cy="sms-message">{value}</span>
          </>
        );
      },
    },
    {
      label: i18next.t('labels.from'),
      key: 'from',
      width: '200px',
      render(value: any) {
        return <span data-cy="sms-from">{value}</span>;
      },
    },
    {
      label: i18next.t('labels.to'),
      key: 'to',
      width: '200px',
      render(value: any) {
        return <span data-cy="sms-to">{value}</span>;
      },
    },
    {
      label: i18next.t('labels.status'),
      key: 'status',
      width: '140px',
      render(value: string) {
        return <span data-cy="sms-status">{capitalize(value)}</span>;
      },
    },
  ];
};
